(function ($) {

    $(document).ready(function () {
        setupTopNavDropdowns();
        launchMobileNav();
    });

    function setupTopNavDropdowns() {
        window.getours.Navigation.subscriptionHandler = new getours.Navigation.SubscriptionHandler();

        var $topNavDropdownLinks = $('.menu-dropdown-link');
        var $vacationFilterButtons = $('.filterStripItem > .dropdown > button, .filterSortResults > .dropdown > button');
        var $allSubscribedDropdowns = $topNavDropdownLinks.add($vacationFilterButtons);

        var topNavDropdownCallback = function ($current, $target) {
            if (!$current || !$target) {
                return;
            }

            var $panel = $($current.attr('data-dropdown'));
            var isCurrentTarget = $current.is($target);

            if (isCurrentTarget) {
                // Make sure not to open a clicked menu that was already active
                // clicking an active menu item should close it and not open it
                $current.toggleClass('open');
                $panel.toggleClass('active');
            } else {
                $current.removeClass('open');
                $panel.removeClass('active');
            }            
        };

        var vacationFilterCallback = function ($current, $target) {
            if (!$current || !$target) {
                return;
            }

            var $wrapper = $current.closest('.popdown-panel');
            var isCurrentTarget = $current.is($target);

            if (isCurrentTarget) {
                // Make sure not to open a clicked menu that was already active
                // clicking an active menu item should close it and not open it
                $wrapper.toggleClass('open');

            } else {
                $wrapper.removeClass('open');
            }
        };

        // THIS SETS UP THE CALLBACKS FOR ALL OF THE DDs IN THE TOP NAV
        _.each($topNavDropdownLinks, function (t) {
            var subscription = new getours.Navigation.Subscription($(t), topNavDropdownCallback);
            window.getours.Navigation.subscriptionHandler.addSubscription(subscription);
        });

        // THIS SETS UP THE CALLBACKS FOR ALL OF THE DDs IN THE VACATION FILTER
        _.each($vacationFilterButtons, function (t) {
            var subscription = new getours.Navigation.Subscription($(t), vacationFilterCallback);
            window.getours.Navigation.subscriptionHandler.addSubscription(subscription);
        });

        // THIS IS WHERE WE FIRE OFF AN EVENT
        $allSubscribedDropdowns.on('click', function (e) {
            var $this = $(this);

            // Notify everyone of new nav state
            window.getours.Navigation.subscriptionHandler.notify($this);

            // close sub nav when this is opened
            $('.pagetop-subnav-item.open').removeClass('open');

            e.preventDefault();
            e.stopPropagation();
            return false;
        });

        setupTouchBodyMenuHide();
    }

    // Allow users to click anywhere outside the top nav to get rid of dropdown
    // -- for the 2020 top navigation redesign [GET35]
    function setupTouchBodyMenuHide() {
        $(window).on("click", function (e) {
            $('.menu-dropdown-link.open').removeClass('open');
            $('.expanded-nav.active').removeClass('active');
            $('.pagetop-subnav-item.open').removeClass('open');
        });
    }

    function launchMobileNav() {
        var menu = new Mmenu("#get-mobile-menu", {
            "slidingSubmenus": false,
            "extensions": [
                "position-left",
                "fullscreen"
            ],
            navbar: {
                add: false
            },
            "navbars": [
                {
                    "content": [
                        "<a href='javascript:;' class='dialog-close' aria-label='close menu'></a>"
                    ]
                }
            ],
            keyboardNavigation: {
                enable: true,
                enhance: true
            },
            screenReader: {
                aria: false
            },
            scrollBugFix: {
                fix: false
            },
            hooks: {
                "open:finish": function (panel) {
                    setTimeout(function () {
                        $hamburger.addClass("is-active");
                    }, 100);
                },
                "close:finish": function (panel) {
                    setTimeout(function () {
                        $hamburger.removeClass("is-active");
                    }, 100);
                }
            }
        },
        {
            classNames: {
                selected: "active"
            },
            offCanvas: {
                page: {
                    selector: ".wrapper"
                }
            },
            screenReader: {
                text: {
                    closeMenu: "Close menu",
                    closeSubmenu: "Close submenu",
                    openSubmenu: "Open submenu",
                    toggleSubmenu: "Toggle submenu"
                }
            }
        });

        var API = menu.API;

        var $hamburger = $(".hamburger");
        $hamburger.on("click", function () {
            API.open();
        });

        var $searchicon = $(".top-search");
        $searchicon.on("click", function () {
            API.open();
        });

        var $page = $(".mm-page");
        $page.on("click", function () {
            API.close();
        });

        var $close = $(".dialog-close");
        $close.on("click", function () {
            API.close();
        });

        // pull search destination from desktop search form action
        var desktopSearchForm = $('#search_form');
        var searchDestination = desktopSearchForm.attr('action');
        $('.mm-search input').on('keyup', function (e) {
            var searchText = $(this).val();
            if (e.keyCode == 13) {
                window.location.href = searchDestination + '?s=' + searchText;
            }
        });
    }

})(jQuery);